/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SurveyAnswerValueType {
  Int4SatisfactionScore = 'Int4SatisfactionScore',
  Text500 = 'Text500'
}
